
import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"
import { cn } from "@/lib/utils"

const ScrollBarThumb = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaThumb>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaThumb>
>(({ className, ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaThumb 
    ref={ref}
    className={cn(
      "relative flex-1",
      "bg-slate-300 dark:bg-slate-600/80",
      "rounded-full",
      "opacity-60 hover:opacity-80",
      "transition-opacity duration-150 ease-in-out",
      className
    )}
    {...props}
  />
))
ScrollBarThumb.displayName = ScrollAreaPrimitive.ScrollAreaThumb.displayName

export { ScrollBarThumb }
